export const statusColor = (status) => {
  switch (status) {
    case 'PENDING':
      return '#F0AD4E'
    case 'APPROVED':
      return '#5CB85C'
    case 'REJECTED':
      return '#D44B49'
    case 'UNSUBMITTED':
      return '#BBBBBB'
    case 'NONSUBMIT':
      return '#BBBBBB'
    case 'CANCEL':
      return '#BBBBBB'
    default:
      return null
  }
}




// WEBPACK FOOTER //
// ./src/components/report/helpers/color.js